import type { HydrationError } from './types.ts';

/**
 * Normalizes a hydration error type by stripping the "UNSAFE_" prefix.
 *
 * Returns null if the error has no type.
 */
const normalizeHydrationErrorType = (error: HydrationError): string | null => {
	if (!error.type) {
		return null;
	}

	return error.type.startsWith('UNSAFE_') ? error.type.slice(7) : error.type;
};

/**
 * Returns a count of each hydration error type
 * (e.g. { SERVER_MISMATCH: 3, CLIENT_MISMATCH: 1 }) for lightweight
 * grouping in analytics, independent of the detailed logging gate.
 * Normalizes error types.
 */
export const getHydrationErrorCounts = (
	hydrationErrors: HydrationError[],
): Record<string, number> => {
	const counts: Record<string, number> = {};

	for (const error of hydrationErrors) {
		const normalizedType = normalizeHydrationErrorType(error);
		if (normalizedType) {
			counts[normalizedType] = (counts[normalizedType] || 0) + 1;
		}
	}
	return counts;
};
